import React from 'react'
import classNames from 'classnames'
import {useFormContext} from "react-hook-form";
import CustomError from './custom_error'
import {useSelector} from "react-redux";
import {useOptionValues, useFormFieldAttributes} from "../../utils"
import InputMask from "react-input-mask";
import RenderedHtmlContent from "../../../../../shared/virtual_congress/components/rendered_html_content";

const Corona3gDatetimeField = ({tagOwner, field, formMode}) => {
  const {
    fieldName,
    labelWidth,
    inputWidth,
    title,
    fieldMode,
    hint,
    errorMessage,
    prefill
  } = useFormFieldAttributes(formMode, field)
  const optionValues = useOptionValues(formMode, field)
  const {register} = useFormContext();

  return (fieldMode != "readonly" &&
    <div className="form-group corona-3g-datetime-container row" id={"form-group-" + field} key={field}>
      <label htmlFor={fieldName} id={field}
             className={"col-md-" + labelWidth + " r-label col-form-label-sm"}>{title || field}</label>
      <div className={"col-md-" + inputWidth}>
        <InputMask
            id={fieldName}
            {...register(fieldName)}
            defaultValue={prefill ? tagOwner  && tagOwner[field] : ""}
            className={classNames("form-control form-control-sm w-100", {"is-invalid": errorMessage})}
            mask={
                [
                    /[1-9]/,
                    /[0-9]/,
                    ".",
                    /[0-9]/,
                    /[0-9]/,
                    ".",
                    "2",
                    "0",
                    "2",
                    "2",
                    " ",
                    /[0-9]/,
                    /[0-9]/,
                    ":",
                    /[0-9]/,
                    /[0-9]/,
                ]}
            alwaysShowMask={true}
            maskPlaceholder="dd.mm.jjjj hh:mm"
        />
        {hint && <small className="form-text text-muted">
          <RenderedHtmlContent html={hint}/>
        </small>}
        <CustomError error={errorMessage}/>
        </div>
    </div>
  )
}

export default Corona3gDatetimeField;
